/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { FeedsUpdatePathParams, FeedsUpdateRequest, FeedsUpdateResponse } from '../types/FeedsUpdate'

/**
 * PUT /ad-generation/feeds/:feed
 * @see backend/nexus/modules/AdGeneration/Http/Controllers/FeedController.php FeedController::update
 */
export async function feedsUpdate(
	feed: FeedsUpdatePathParams['feed'],
	data: FeedsUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<FeedsUpdateResponse>> {
	return axiosInstance.put(`/ad-generation/feeds/${feed}`, data, config)
}
